document.addEventListener('DOMContentLoaded', function () {

    $('.switches input#elec_vat').on('click', function () {
        vat = $(this).prop('checked') ? 'true' : 'false';
        getData('electricity', selectedDate, period, vat, tax, elec_chart);
    });

    $('.switches input#gas_vat').on('click', function () {
        vat = $(this).prop('checked') ? 'true' : 'false';
        getData('gas', selectedDate, period, vat, tax, gas_chart);
    });

    $('.switches input#elec_tax').on('click', function () {
        tax = $(this).prop('checked') ? 'true' : 'false';
        getData('electricity', selectedDate, period, vat, tax, elec_chart);
    });

    $('.switches input#gas_tax').on('click', function () {
        tax = $(this).prop('checked') ? 'true' : 'false';
        getData('gas', selectedDate, period, vat, tax, gas_chart);
    });

});